<template lang="html">
	<Modal
		:show="showIPFModal"
		content_class="col-12 col-md-9 col-lg-8 col-xl-6 ipf-modal"
	>
		<template slot="content">
			<div>
				<div class="clearfix top">
					<div class="left-content f-l">
						<div class="content-title">Get IPF</div>
					</div>
					<div class="close-modal f-r" @click="closeModal(0)">
						<i class="fa fa-times"></i>
					</div>
				</div>

				<div v-if="ipfPage === 1" class="row">
					<div class="col-12 col-md-11 col-lg-10 col-xl-9">
						<div class="card card-details">
							<div class="top">
								<div class="icon-box f-l"></div>
								<div class="detail-box f-l">
									<div class="item-name">
										{{ product.product_name }}
									</div>
									<div class="insurance">
										{{ product.underwritter_name }}
									</div>
								</div>
							</div>
							<div class="bottom">
								You are requesting IPF for Max:
								<b
									>{{
										product.product_account_details
											.currency_code
									}}
									{{
										utils.numberWithCommas(
											Math.round(
												product.invoice_details
													.total_amount * 100,
											) / 100,
										)
									}}</b
								>
							</div>
						</div>

						<!-- <div class="txt">Select Bank:</div>
                  <div class="card">

                  </div> -->

						<div class="card">
							<Form
								classBinding="row"
								:ref="IPFModel.forms.ipf.name"
								:forms="IPFModel.forms.ipf.forms"
								:form_data="IPFModel.forms.ipf.data"
							/>
						</div>

						<div class="actions">
							<!-- <div class="price-box f-l">
                        <div class="price tx-blue">
                           {{product.product_account_details.currency_code}} {{utils.numberWithCommas(Math.round(product.invoice_details.total_amount*100)/100)}}<span class="point">.00</span>
                        </div>
                        <div class="txt">Total</div>
                     </div> -->
							<!-- <div class="btn btn-primary f-r">Make Request</div> -->
							<div
								class="btn btn-primary btn-long"
								@click="
									checkIPFEligibility({
										ref: $refs[IPFModel.forms.ipf.name],
									})
								"
								:disabled="loading"
							>
								Make Request
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="ipfPage === 2" class="row">
					<div class="col-12 col-md-11 col-lg-10 col-xl-9">
						<div class="card card-details">
							<div class="top">
								<div class="icon-box f-l"></div>
								<div class="detail-box f-l">
									<div class="item-name">IPF Products</div>
									<div class="insurance">
										Select IPF product
									</div>
								</div>
							</div>
							<!-- <div class="bottom">You are requesting IPF for Max: <b>{{product.product_account_details.currency_code}} {{utils.numberWithCommas(Math.round(product.invoice_details.total_amount*100)/100)}}</b></div> -->
						</div>

						<!-- <div class="txt">Select Bank:</div>
                  <div class="card">

                  </div> -->

						<div class="card">
							<Form
								classBinding="row"
								:ref="IPFModel.forms.ipfProduct.name"
								:forms="IPFModel.forms.ipfProduct.forms"
								:form_data="IPFModel.forms.ipfProduct.data"
							/>
						</div>

						<div class="actions">
							<div
								class="btn btn-yellow btn-long"
								v-show="showTopUpButton"
								@click="
									$store.commit('showIPFModal', false);
									$router.push({ name: 'TopUpOptions' });
								"
							>
								Top Up
							</div>
							<div
								v-show="!showTopUpButton"
								class="btn btn-primary btn-long"
								@click="
									getOffer({
										ref: $refs[
											IPFModel.forms.ipfProduct.name
										],
									})
								"
								:disabled="loading"
							>
								Get Offer
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="ipfPage === 3">
					<div class="msg-box success">
						<img src="/img/group.svg" alt="" />
						<div class="msg-text">Loan Offer Available</div>
						<div class="msg-text">
							Invoice Number:{{
								offer.invoice_details.invoice_number
							}}
						</div>
					</div>

					<div class="card card-offer">
						<div class="body">
							<div class="minimum">
								The minimum required deposit amount is:
								{{
									product.product_account_details
										.currency_code
								}}
								{{
									utils.numberWithCommas(
										Math.round(
											offer.offer.upfront_payment_amount *
												100,
										) / 100,
									)
								}}. Your account balance is KES
								{{
									product.product_account_details
										.currency_code
								}}
								{{
									utils.numberWithCommas(
										Math.round(balance * 100) / 100,
									)
								}}.
							</div>
							<div
								class="minimum"
								v-if="
									balance < offer.offer.upfront_payment_amount
								"
							>
								You have insufficient funds top up with
								{{
									product.product_account_details
										.currency_code
								}}
								{{
									utils.numberWithCommas(
										Math.round(
											(offer.offer
												.upfront_payment_amount -
												balance) *
												100,
										) / 100,
									)
								}}
								to accept the offer.

								<button
									class="btn btn-sm btn-grey"
									@click="
										$store.commit('showIPFModal', false);
										$router.push({ name: 'TopUpOptions' });
									"
								>
									Top Up
								</button>
							</div>
							<div class="loan-offer">
								<div class="title">Loan Breakdown</div>
								<div class="item">
									<div class="row">
										<div
											class="col-12 col-sm-6 col-md-8 name"
										>
											Payable Upfront
										</div>
										<div
											class="col-12 col-sm-6 col-md-4 price"
										>
											{{
												product.product_account_details
													.currency_code
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														offer.offer
															.upfront_payment_amount *
															100,
													) / 100,
												)
											}}
										</div>
									</div>
								</div>
								<div class="item">
									<div class="row">
										<div
											class="col-12 col-sm-6 col-md-8 name"
										>
											Charges
										</div>
										<div
											class="col-12 col-sm-6 col-md-4 price"
										>
											{{
												product.product_account_details
													.currency_code
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														offer.offer
															.total_charges *
															100,
													) / 100,
												)
											}}
										</div>
									</div>
								</div>
								<div class="item">
									<div class="row">
										<div
											class="col-12 col-sm-6 col-md-8 name"
										>
											Monthly Payable
											<span class="small bold"
												>in ({{
													offer.application_details
														.loan_tenor
												}}
												Months)</span
											>
										</div>
										<div
											class="col-12 col-sm-6 col-md-4 price"
										>
											{{
												product.product_account_details
													.currency_code
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														offer.offer
															.payment_amount *
															100,
													) / 100,
												)
											}}
										</div>
									</div>
								</div>

								<!-- <div class="item total">
                           <div class="row">
                              <div class="col-12 col-sm-6 col-md-8 name">Total Payable</div>
                              <div class="col-12 col-sm-6 col-md-4 price">
                                 {{product.product_account_details.currency_code}} {{utils.numberWithCommas(Math.round(loan.totalPayable*100)/100)}}
                              </div>
                           </div>
                        </div> -->
							</div>
						</div>
					</div>

					<div class="insurance">Payment Schedule</div>
					<div class="card card-details">
						<div class="schedule">
							<div class="row title">
								<div class="col-md-6">
									<div class="txt">Date</div>
								</div>
								<div class="col-md-3">
									<div class="txt">Payment to Principle</div>
								</div>
								<div class="col-md-3">
									<div class="txt">Payment to Interest</div>
								</div>
							</div>
							<div
								class="row"
								v-for="(s, i) of offer.offer.payment_schedule"
								:key="i"
							>
								<div class="col-md-6">
									<div class="txt">
										{{
											moment(s.paymentDate).format(
												'Do MMMM YYYY',
											)
										}}
									</div>
								</div>
								<div class="col-md-3">
									<div class="txt">
										{{
											Math.round(
												s.paymentToPrinciple * 100,
											) / 100
										}}
									</div>
								</div>
								<div class="col-md-3">
									<div class="txt">
										{{
											Math.round(
												s.paymentToInterest * 100,
											) / 100
										}}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card">
						<Form
							classBinding="row"
							:ref="IPFModel.forms.ipfPayment.name"
							:forms="IPFModel.forms.ipfPayment.forms"
							:form_data="IPFModel.forms.ipfPayment.data"
						/>
					</div>

					<div class="bottom">
						<div class="row">
							<div class="col-6">
								<div
									:disabled="loading"
									class="btn btn-long btn-red"
									@click="cancelRequest()"
								>
									Cancel
								</div>
							</div>
							<div class="col-6">
								<div
									:disabled="loading"
									class="btn btn-long btn-primary"
									@click="
										acceptIPF({
											ref: $refs[
												IPFModel.forms.ipfPayment.name
											],
										})
									"
								>
									Accept
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import ipf from '../../rsc/stores/ipf.store';

export default {
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('./modal'),
	},
	beforeDestroy() {
		this.$store.unregisterModule('ipf');
	},
	created() {
		utils.registerModule('ipf', ipf, this.$store);

		Event.$on('ipf:show', async (payload) => {
			Event.$emit('loader:show', true);
			console.log(payload);
			this.$store.commit('product', payload.item);
			await this.$store.dispatch('initializeIPF');
		});
	},
	computed: {
		...mapGetters([
			'loading',
			'IPFModel',
			'showTopUpButton',
			'showIPFModal',
			'showIPF',
			'ipfPage',
			'bank',
			'amount',
			'loanID',
			'loan',
			'balance',
			'charges',
			'product',
			'offer',
		]),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions([
			'requestIPF',
			'getOffer',
			'acceptIPF',
			'cancelRequest',
			'checkIPFEligibility',
		]),
		closeModal(type) {
			if (type === 0) {
				this.$store.commit('showIPFModal', false);
			} else if (type === 1) {
			}
		},
	},
	mounted() {
		utils.registerModule('ipf', ipf, this.$store);
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.schedule {
	font-size: 13px;
	// margin: 0 0 40px 0;

	.title {
		font-weight: 600;
	}
}
.ipf-modal {
	.item-name {
		font-weight: 600;
		font-size: 14px;
	}
	.insurance {
		font-size: 13px;
		color: var(--ne-red);
		font-weight: 600;
	}
	.bold {
		font-weight: 600;
	}

	.card-offer {
		margin: 20px 0 30px 0 !important;

		.top {
			border-bottom: solid 1px #efefef;
			padding: 0 0 10px 0;
			margin: 0 0 30px 0;
		}
		.logo {
			width: 35px;
			height: auto;
			margin: 0 20px 0 0;
		}

		.bank-box,
		.price-box {
			font-weight: 600;

			.small {
				font-weight: 600;
			}
			.bank {
				font-size: 14px;
			}
			.amount {
				color: var(--ne-blue);
			}
		}

		.minimum {
			font-size: 14px;
			margin: 0 0 25px 0;
		}

		.loan-offer {
			.col-12 {
				padding: 0 !important;
			}
			.title {
				font-size: 13px;
				font-weight: 600;
				margin: 0 0 20px 0;
				border-bottom: solid 1px #efefef;
				display: inline-block;
			}
			.title-small {
				font-size: 13px;
				font-weight: 600;
				margin: 20px 0 5px 0;
				border-bottom: solid 1px #efefef;
				display: inline-block;
			}
			.item {
				margin: 2px 0;

				.col-12 {
					margin: 0 !important;
				}
				.name {
					font-size: 14px;
					font-weight: 600;
				}
				.price {
					font-size: 15px;
					font-weight: 600;
				}
			}
			.item.total {
				margin: 15px 0 0 0;

				.name {
					padding: 10px 0 !important;
				}
				.price {
					border-top: solid 1px #efefef;
					padding: 10px 0 !important;
					border-bottom: solid 1px #efefef;
				}
			}
		}
	}
	.msg-box {
		margin: 60px 0 0 0;
		text-align: center;

		img {
			max-width: 150px;
			width: auto;
			height: auto;
		}
		.msg-text {
			font-size: 15px;
			margin: 3px 0 0 0;
			font-weight: 600;
		}
	}
	.msg-box.success {
		color: var(--success);
	}
}
</style>
